export default __webpack_public_path__ + "static/q_apricoat-3a4438f5519c8bae295e0495fb0c7913.png";